export default {

// SECTION TOP
    title: `La beauté responsable et engagée`,
    subTitle:`Objectifs durables`,
    

// CONTENT

    content1: `<strong>L’industrie cosmétique n’échappe pas aux enjeux de responsabilité sociale et environnementale</strong>, que ce soit dans son activité, sa production ou sa communication. Certains groupes font même évoluer leur offre de <span class='renvoi' data-tippy-content='Clean beauty : littéralement beauté propre, tendance à développer des cosmétiques à partir de substances naturelles et sans produits chimiques. On parle également de beauté verte ou green beauty lorsqu’il s’agit d’être le plus transparent possible sur la composition des produits.'><em>clean beauty</em></span>, en faveur d’une cosmétique plus naturelle et saine, vers une offre engagée. <br/>
    Ils passent ainsi de la <em>green beauty</em>, qui se concentre principalement sur la composition des produits, à la <em>blue beauty</em>, qui aspire à ne négliger aucune étape, de la fabrication à la distribution, tout en menant des actions concrètes pour la préservation de l’environnement.`,

    content2: `Une démarche et des initiatives plus globales qui répondent aux exigences accrues des consommateurs et des labels écoresponsables. La certification <span class='renvoi' data-tippy-content='COSMetic Organic and natural Standard'>COSMOS</span> d’Ecocert exige par exemple, en plus de l’absence d’ingrédients pétrochimiques (hors conservateurs autorisés), le respect de la biodiversité et des emballages recyclables.`,

    title3: `Des initiatives variées`,
    content3_1: `Avec la <em>blue beauty</em>, l’univers de la beauté rencontre celui de l’éthique. À l’origine, le qualificatif « bleu » cible plus particulièrement la protection des océans. Certaines marques pionnières se sont engagées il y plus de dix ans pour la préservation de l’écosystème marin aux côtés des fondations. D’autres ont développé des gammes de protections solaires respectueuses des océans. Un sujet non négligeable quand on sait que chaque année, 25 000 tonnes d’actifs chimiques issus des crèmes solaires sont déversées dans les océans, mettant en péril l’écosystème marin et les récifs coralliens.`,
    content3_2: `Les grands groupes quant à eux, revendiquent la prise en compte de tous les impacts, directs et indirects, de leur activité – lutte contre le changement climatique, gestion responsable de l’eau, préservation des ressources naturelles –, et créent des fondations au service de la restauration des écosystèmes endommagés.`,
    content3_3: `Enfin, d’autres marques incluent dans leur politique RSE une action de régénération des sols ainsi qu’un engagement sociétal et local, en créant par exemple des réseaux de commerces équitables. Elles bouclent ainsi la démarche, en prenant soin à la fois de ses ressources et des personnes engagées dans sa production.`,
    signature: `Par Cécile Cau, journaliste.`,


// KEY FIGURES
    keyFigures: [
	    {
	        figure: 8,
	        suffix: `%`,
	        content: `C’est le rebond du marché cosmétique mondial en 2021 (pour un total de 228 Mds € dont 35 % réalisés en Asie).`,
	        topImage: `Profiting_001.svg`,
	        noCollapse: true,
	        noMarge: true,
	    },
	    {
	        figure: 48,
	        suffix: `milliards`,
	        content: `de dollars, c’est le chiffre qui pourrait être atteint en 2024 pour le marché mondial des cosmétiques naturels.`,
	        topImage: `Profiting_002.svg`,
	        noCollapse: true,
	    },

    ],


};

